export const BILLING_API = {
  appointments: {
    base: '/appointments'
  },
  tasks: {
    base: '/tasks'
  }
};
